import { useCallback } from 'react';
import { useAuth } from 'src/auth/useAuth';

function useErisSecurityService() {
  const { clearError, loadUser, login, logout, user } = useAuth();

  const erisLoginUser = useCallback(async () => {
    clearError();
    login();
  }, [clearError, login]);

  const erisLogoutUser = useCallback(async () => {
    await logout();
  }, [logout]);

  const getUser = useCallback(async () => {
    if (user) return user;
    return await loadUser();
  }, [loadUser, user]);

  return { erisLoginUser, erisLogoutUser, getUser };
}

export default useErisSecurityService;
